import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import {getLoadsCount, getTrucksCount, setDeadhead} from '~/modules/rate/actions';
import mapDispatch from '~/misc/mapDispatch';
import Spinner from '~/components/common/Spinner';
import RatioSelect from '../ratioSelect';
const Histogram = (props) => {
  let trucks = Number(props.trucks);
  let loads = Number(props.loads);
  let max = trucks > loads ? trucks : loads;
  let trucksWidth, loadsWidth;
  if (max === 0 || !max) {
    trucksWidth = 0;
    loadsWidth = 0;
  } else if (trucks === 0) {
    trucksWidth = 0;
    loadsWidth = 100;
  } else if (loads === 0) {
    trucksWidth = 100;
    loadsWidth = 0;
  } else {
    trucksWidth = (trucks / max * 100) < 1 ? 1 : (trucks / max * 100);
    loadsWidth = (loads / max * 100) < 1 ? 1 : (loads / max * 100);
  }
  return (
    <div>
      <div className={cs(css.boxInfo, css.trucks)}>
        <label>Trucks:</label>
        <div className={cs(css.setting)}>
          <span
            className={cs(css.plan)}
            style={{width: `${trucksWidth }%`}}
          />
          <span
            className={cs(css.planNumber, (trucksWidth > 80) && css.planMiddle)}
            style={{left: `${trucksWidth }%`}}
          >{trucks}</span>
        </div>
      </div>
      <div className={cs(css.boxInfo)}>
        <div className={cs(css.divider)} />
      </div>
      <div className={cs(css.boxInfo, css.loads)}>
        <label>Loads:</label>
        <div className={cs(css.setting)}>
          <span
            className={cs(css.plan)}
            style={{width: `${loadsWidth }%`}}
          />
          <span
            className={cs(css.planNumber, (loadsWidth >= 80) && css.planMiddle)}
            style={{left: `${loadsWidth }%`}}
          >{loads}</span>
        </div>
      </div>
    </div>
  );
};

class TruckLoadRatio extends React.Component {
  constructor(props) {
    super(props);
    this.initialize = this.initialize.bind(this);
  }
  componentWillMount() {
    const arr = [this.props.pickLoads, this.props.pickTruck, this.props.dropLoads, this.props.dropTrucks];
    if (arr.indexOf('undefined') !== -1) {
      const pickup = this.props.pickup;
      const dropOff = this.props.dropOff;
      const equipment = this.props.equipment;
      const deadhead = this.props.deadhead;
      this.props.getLoadsCount({pickup, dropOff, equipment, deadhead});
      this.props.getTrucksCount({pickup, dropOff, equipment, deadhead});
    }
  }
  render() {
    const arr = [this.props.pickLoads, this.props.pickTruck, this.props.dropLoads, this.props.dropTrucks];
    const deadhead = this.props.deadhead;
    if (arr.indexOf('undefined') !== -1) {
      return (
        <div className={css.spinnerLine}>
          <div className={css.spinner}>
            <Spinner scalable={true}/>
          </div>
        </div>
      )
    }
    return (
      <div className={cs(css.loadRatio)}>
        <div className={cs(css.loadRatioContent)}>
          <div className={cs(css.ratioHeader, !this.props.optional && css.hiddenHeader)}>
            {!this.props.optional ? <span className={cs(css.headerRight)}>within ({deadhead})miles</span>
              : <span className={cs(css.selectBox)}>
                <span className={cs(css.deadhead)}>Deadhead</span>
                <span className={cs(css.selectWrap)}><RatioSelect
                  update={this.initialize}
                  setDeadhead={this.props.setDeadhead}
                  deadhead={this.props.deadhead}
                /></span>
              </span>}
          </div>
          <div className={cs(css.information)}>
            <div className={cs(css.informationLeft)}>
              <p className={cs(css.address)}>
                <img src='/assets/icon-place-green.svg'/>
                <span className={cs(css.location)}>{this.props.pick}</span>
              </p>
              <div className={cs(css.box)}>
                <Histogram
                  trucks={this.props.pickTruck}
                  loads={this.props.pickLoads}
                />
              </div>
              <div className={cs(css.quantity)}>
                <span>Truck to Load Ratio : </span>
                {this.props.pickTruck} trucks to {this.props.pickLoads} loads.
              </div>
            </div>
            <div className={cs(css.informationLeft)}>
              <p className={cs(css.address)}>
                <img src='/assets/icon-place-blue.svg'/>
                <span className={cs(css.location)}>{this.props.drop}</span>
              </p>
              <div className={cs(css.box)}>
                <Histogram
                  trucks={this.props.dropTrucks}
                  loads={this.props.dropLoads}
                />
              </div>
              <div className={cs(css.quantity)}>
                <span>Truck to Load Ratio : </span>
                {this.props.dropTrucks} trucks to {this.props.dropLoads} loads.
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
  initialize(data) {
    const pickup = this.props.pickup;
    const dropOff = this.props.dropOff;
    const equipment = this.props.equipment;
    const deadhead = data;
    this.props.getLoadsCount({pickup, dropOff, equipment, deadhead});
    this.props.getTrucksCount({pickup, dropOff, equipment, deadhead});
  }
}
export default connect(({rate}, props) => {
  const deadhead = props.optional ? rate.deadhead : props.deadhead;
  return {
    pickLoads: rate.pickLoads,
    pickTruck: rate.pickTruck,
    dropLoads: rate.dropLoads,
    dropTrucks: rate.dropTrucks,
    deadhead: deadhead,
  };
}, mapDispatch({
  getLoadsCount: (props, data) => getLoadsCount(data),
  getTrucksCount: (props, data) => getTrucksCount(data),
  setDeadhead: (props, data) => setDeadhead(data),
}))(TruckLoadRatio);



// WEBPACK FOOTER //
// ./src/components/rate/common/loadRatio/index.js